export function setGuidanceConfig (state, payload) {
  state.guidanceConfig = payload
}
